import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, catchError, map, throwError} from 'rxjs';
import {AppConfigurationService} from '../../../erp/services/base/appConfiguration.service';

@Injectable({
  providedIn: 'root',
})
export class FotoValidacaoService {
  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService,
  ) {}

  enviarFotoParaValidar(files: any): Observable<Number> {
    const formData = new FormData();
    formData.append('file', files);
    return this.httpClient
      .post<Number>(`${this.appConfigurationService.apiBaseUrl}/FaceValidation/validate`, formData)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
  cadastrarVida(arquivo: any, idProposta: string, idBeneficiario: string, ehDependente: boolean): Observable<Number> {
    const formData = new FormData();
    formData.append('SelfieBeneficiario', arquivo);
    formData.append('ProposalId', idProposta);
    formData.append('BeneficiaryId', idBeneficiario);
    formData.append('IsDependent', ehDependente.toString());
    return this.httpClient.post<Number>(`${this.appConfigurationService.apiBaseUrl}/MedSenior/Vida`, formData).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  obterStatusMedSenior(idProposta: string): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/MedSenior/Proposal/${idProposta}/MedSenior-Create-Status`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  obterAvaliacaoSaude(idProposta: string): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/MedSenior/Avaliacao-Saude?proposalId=${idProposta}`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
}
